module.exports = __webpack_public_path__ + "img/samoilova.96164c99.png";